module.exports = __webpack_public_path__ + "img/zu2.49db8b3b.jpg";